<template>
  <b-col lg="12">
    <b-card>
      <b-card-header
        v-if="!loading"
        style="border-bottom: 0px !important; font-size: 1.4em"
      >
        <b style="color: #20a8d8">{{ model }}</b> Failure Details
        <small style="margin-left: 15px"> Total: {{ total }} </small>
        <b-button
          class="download-button"
          variant="primary"
          @click="downloadExcel()"
        >
          <LoadingCard
            v-if="loading2019"
            width="20px"
            height="20px"
          ></LoadingCard>
          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>Download
        </b-button>
        <b-form-group style="display: inline-block; margin-bottom: 15px">
          <b-input-group size="xl">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
              >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-card-header>
      <b-table
        responsive="sm"
        :busy.sync="loading"
        id="my-table"
        :items="myProvider"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template v-slot:cell(failTracking)="data">
          <a v-bind:href="$customerReportPath(data.item.fnsid)">{{
              data.item.failTracking
            }}</a>
        </template>
        <template v-slot:cell(user)="data">
          <img class="img-avatar table-img" size="xs" :src="data.item.user" />
        </template>
      </b-table>
      <div style="display:flex;justify-content: center; width: 100% ">
        <div style="display:flex;justify-content: center; width: 400px; ">
          <b-pagination
            style="margin-right: 10px;"
            v-show="total > 0"
            :total-rows="rows"
            v-model="currentPage"
            :per-page="perPage"
            aria-controls="my-table"
            page-class="customPage"
          ></b-pagination>
          <b-form-select
            v-show="total > 0"
            v-model="perPage"
            :options="options"
            class="select"
          ></b-form-select>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "FailureDetailsTable",
  props: ["part", "model"],
  data: () => {
    return {
      params: {},
      excelDownload: "",
      loading2019: false,
      loadingExcel: false,
      productGroupParam: "",
      partParam: "",
      link: "all",
      filter: null,
      dateFrom: "",
      dateTo: "",
      modalDate: false,
      newcomid: "",
      title: "",
      loading: false,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        {key: "failTracking", label: "FNSID-RA", sortable: true},
        {key: "productManufacturer", label: "Manufacturer", sortable: true},
        {key: "ARR_RA", label: "ARR RA"},
        {key: "failDate", label: "Date"},
        {key: "user", label: "Technician"},
        {key: "failure_desc", label: "Failure", sortable: true},
        {key: "resolution_desc", label: "Resolution", sortable: true},
        {key: "refDes", label: "Designator"},
        {key: "resBoard", label: "Board"},
        {key: "Complaint", label: "Complaint"},
        {key: "city", label: "Customer/City"}
      ],
      options: [
        {value: 10, text: "10"},
        {value: 20, text: "20"},
        {value: 50, text: "50"},
        {value: 100, text: "100"}
      ],
      perPage: 10,
      currentPage: 1
    };
  },
  computed: {
    rows() {
      return this.total;
    }
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        xml: "true",
        fns_part: this.partParam
      };
      this.$http
        .get("api/comcast_portal/products/getFailureDetails.php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    async myProvider(ctx) {
      this.params["limit"] = ctx.perPage;
      this.params["offset"] = ctx.currentPage - 1;
      this.params["fns_part"] = this.partParam;

      this.loading = true;
      try {
        const response = await this.$http.get(
          "api/comcast_portal/products/getFailureDetails.php",
          {
            params: this.params
          }
        );
        if (response.data && response.data.records) {
          this.loading = false;
          this.total = response.data.count;
          return response.data.records;
        } else {
          this.message = response.data.message;
          this.loading = false;
          this.params = {};
        }
      } catch (error) {
        this.total = 0;
        this.loading = false;
        this.params = {};
        return [];
      }
    }
  },
  mounted() {
    this.dateFrom = "2021-01-01";
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.partParam = this.part;
  },
  components: {LoadingCard}
};
</script>
<style>
.table-img {
  height: 35px;
  display: block;
  margin: auto;
}

.complaintClass {
  width: 200px;
}

.download-button {
  width: 150px;
  margin: auto;
  margin-left: 10px;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.sk-double-bounce {
  display: inline-block;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}

.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}

.gm-style .gm-style-iw-d {
  color: black !important;
}

.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}

.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}

.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}

.vdp-datepicker .input-group input {
  background: #515b65 !important;
}

.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.page-link {
  background-color: #2f353a;
  color: white;
}

.page-item.disabled .page-link {
  background-color: #515b65;
  color: white;
}

.page-link:hover {
  background-color: #515b65;
  color: white;
}

.select {
  background-color: #2f353a;
  color: white;
}
</style>
